interface LabelProps {
  htmlFor: string;
  children: React.ReactNode;
  className?: string;
  required?: boolean;
}

const Label: React.FC<LabelProps> = ({ htmlFor, children, className = '', required = false }) => {
  return (
    <label
      htmlFor={htmlFor}
      className={`block text-lg text-white mb-2 opacity-60 ${className}`}
    >
      {children}
      {required && <span className="text-white ml-1">*</span>}
    </label>
  );
};

export default Label;
